export var AfriexRewardType;
(function (AfriexRewardType) {
    AfriexRewardType["GiftCard"] = "gift_card";
    AfriexRewardType["Coupon"] = "coupon";
    AfriexRewardType["HealthInsurance"] = "health_insurance";
    AfriexRewardType["AirportLounge"] = "airport_lounge";
    AfriexRewardType["ConcertTicket"] = "concert_ticket";
    AfriexRewardType["PrepayGiftCard"] = "prepay_gift_card";
})(AfriexRewardType || (AfriexRewardType = {}));
//# sourceMappingURL=AfriexRewardType.js.map